import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import COLORS from "../../../assets/Colors";
import {
  TabStyle,
  StyledText,
  UpdatesWrapper,
  VideoCard,
  Center,
  GridContainer,
} from "./styles";
import VideoBox from "../Liveresources/VideoBox";
import { Paper } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <TabStyle
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </TabStyle>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    overflow: "hidden",
    width: "100%",
    height: "100%",
    marginTop: "50px",
    "& .MuiTabs-indicator": {
      height: "0px !important",
    },
    "& .MuiTab-root": {
      padding: "6px 12px 6px 0px",
    },
    [theme.breakpoints.up(640)]: {
      borderRadius: "11px",
      border: `solid 1px ${COLORS.HEADER_BORDER} `,
      "& .MuiTabs-indicator": {
        height: "4px !important",
      },
      //   "& .MuiTab-root": {
      //     padding: "6px 12px",
      //   },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    backgroundColor: COLORS.INPUT_BACKGROUND,
    boxShadow: "none",
    [theme.breakpoints.up(640)]: {
      backgroundColor: COLORS.PRIMARY_WHITE,
      borderBottom: `solid 1px ${COLORS.HEADER_BORDER} `,
    },
  },

  label: {
    display: "flex",
    fontFamily: "openSans-SemiBold, sans-serif",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    fontSize: "14px",
    [theme.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },

  "& .MuiTab-root": {
    padding: 0,
  },
}));

export default function VideosTab({ resourceSetting }) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  return (
    <Center className="mui-tabs">
      <UpdatesWrapper>
        <div className={classes.root}>
          <AppBar className={classes.appBar} position="static">
            <Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
              <Tab
                label={<div className={classes.label}>Videos</div>}
                {...a11yProps(0)}
              />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <GridContainer>
              {/* <VerticalWrap> */}
              {resourceSetting?.length ? (
                resourceSetting?.map((video, index) =>
                  video?.uploadVideo.endsWith(".mp4") ? (
                    <Paper
                      style={{
                        padding: 16,
                        backgroundColor: "#E8F9FF",
                      }}
                    >
                      <VideoCard key={index}>
                        <VideoBox src={video?.uploadVideo} />
                      </VideoCard>
                    </Paper>
                  ) : (
                    <Paper
                      style={{
                        padding: 16,
                        backgroundColor: "#E8F9FF",
                      }}
                    >
                      <div
                        style={{
                          margin: "15px",
                        }}
                      >
                        No videos found
                      </div>
                    </Paper>
                  ),
                )
              ) : (
                <Paper
                  style={{
                    padding: 16,
                    backgroundColor: "#E8F9FF",
                  }}
                >
                  <div
                    style={{
                      margin: "15px",
                    }}
                  >
                    No videos found
                  </div>
                </Paper>
              )}
              {/* </VerticalWrap> */}
            </GridContainer>
          </TabPanel>
        </div>
      </UpdatesWrapper>
    </Center>
  );
}
